export default class PersonalityQuizPersonaPercentsModel {
  public personaId: number = null;
  public percent: number = null;
}
